const plugins = require.context('.', true, /.coffee$/)
plugins.keys().forEach(plugins)
